import React from "react";
import { Button } from "@networkraildigitalfactory/components";

const CreateActionButtons = (props) => {
  const {
    status,
    saveObjective,
    openCascadeModal,
    onSubmit,
    isActionsDisabled,
    isDirtyForm,
  } = props;

  switch (status) {
    case "new":
      return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            disabled={isActionsDisabled || !isDirtyForm}
            color={isActionsDisabled || !isDirtyForm ? "grey" : "blue"}
            text="Save as draft"
            name="save as draft"
            onClick={(e) => {
              e.preventDefault();
              saveObjective();
            }}
          />
          <Button
            disabled={isActionsDisabled || !isDirtyForm}
            color={isActionsDisabled || !isDirtyForm ? "grey" : "green"}
            text="Send for approval"
            name="send for approval"
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          />
        </div>
      );
    case "new-cascaded":
      return (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            disabled={isActionsDisabled || !isDirtyForm}
            color={isActionsDisabled || !isDirtyForm ? "grey" : "green"}
            text="Cascade objective"
            name="Cascade objective"
            onClick={(e) => {
              e.preventDefault();
              openCascadeModal();
            }}
          />
        </div>
      );
    default:
      return <></>;
  }
};
export default CreateActionButtons;
